<template lang="pug">
.v-complete-advantages.complete-advantages(v-if="data" :id="data?.id")
	.complete-advantages__left
		.complete-advantages__title(v-if="data.title") {{data.title}}
		.complete-advantages__actions(v-if="data.actions && !isTablet")
			v-action.complete-advantages__action.btn(v-for="action in data.actions" :action="action")
	.complete-advantages__items(v-if="data.items")
		component.complete-advantages__item(v-for="item in data.items" :is="item.link ? 'a' : 'div'" :href="item.link ? item.link : ''")
			.complete-advantages__item-top
				img.complete-advantages__image(v-if="item.image" :src="item.image.src" alt="item.image.alt")
				v-informer.complete-advantages__informer(:info="item.info")
			.complete-advantages__item-title(v-if="item.title" v-html="item.title")
			.complete-advantages__item-text(v-if="item.text" v-html="item.text")
	.complete-advantages__actions(v-if="data.actions && isTablet")
		v-action.complete-advantages__action.btn(v-for="action in data.actions" :action="action")
</template>

<script>

import sourceMixin from "../components/mixins/v-mixin-source.vue";
import isMobMixin from "components/mixins/v-mixin-is-mob.vue";

export default {
	mixins: [
		sourceMixin,
		isMobMixin
	],

	data() {
		return {
			data: null
		}
	},

	methods: {
		dataSet(data) {
			this.data = data;
		}
	}
}

</script>